enum ExternalStatus {
    NOT_FOUND = 'NOT_FOUND',
    BAD_REQUEST = 'BAD_REQUEST',
    UNAUTHORIZED = 'UNAUTHORIZED',
    FORBIDDEN = 'FORBIDDEN',
    INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
    SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
    GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
    CLAROLUZ_SUCCESS = 'CLAROLUZ_SUCCESS',
    CLAROLUZ_NO_OFFERS = 'CLAROLUZ_NO_OFFERS',
    CLAROLUZ_UNKNOWN_ERROR = 'CLAROLUZ_UNKNOWN_ERROR',
    CLAROLUZ_INVALID_PDF = "CLAROLUZ_INVALID_PDF",
    CLAROLUZ_INVALID_CUPS_VALUE = "CLAROLUZ_INVALID_CUPS_VALUE",
    CLAROLUZ_INVALID_CUPS = "CLAROLUZ_INVALID_CUPS",
    CLAROLUZ_INVALID_URL = "CLAROLUZ_INVALID_URL"
}

//removeIf(production)
export default ExternalStatus;
//endRemoveIf(production)